/* SATORU SASAKI: reveal header on scroll up, hide on scroll down */
(function(){
 function init(){
  var header=document.querySelector('[data-section-type="header"]:has(.satoru-header)');
  if(!header)return;
  var last=Math.max(0,window.scrollY||0), ticking=false;
  function update(){
   var y=Math.max(0,window.scrollY||0), delta=y-last;
   var menu=document.querySelector('.satoru-header__menu');
   var menuOpen=menu&&menu.getAttribute('aria-expanded')==='true';
   if(y<70||menuOpen){header.classList.remove('satoru-scroll-hidden');}
   else if(delta>5&&y>header.offsetHeight+30){header.classList.add('satoru-scroll-hidden');}
   else if(delta< -5){header.classList.remove('satoru-scroll-hidden');}
   last=y;ticking=false;
  }
  window.addEventListener('scroll',function(){if(!ticking){ticking=true;window.requestAnimationFrame(update);}}, {passive:true});
  document.addEventListener('click',function(){if(header.classList.contains('satoru-scroll-hidden'))return;setTimeout(function(){var b=document.querySelector('.satoru-header__menu');if(b&&b.getAttribute('aria-expanded')==='true')header.classList.remove('satoru-scroll-hidden');},0);});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
